export default __webpack_public_path__ + "static/media/cole.ec5da74e.webp";